import { AUDIO_GROUP_TYPE } from "../models/dictionary";
import type { AlbumModel } from "../models/models";

export const albums: AlbumModel[] = [
	{
		id: "d12f547c-6a2d-4789-bd3d-e74a37f5b6fe",
		name: "The Originals",
		slug: "the-originals",
		type: AUDIO_GROUP_TYPE.ALBUM,
		collectionIds: ["collection:cafe"],
		description:
			"The original Coffitivity tracks that started it all. Our first three free and premium tracks, recorded in 2013 and 2014, capture the essence of the classic coffee shop ambiance that inspired our brand. These timeless tracks evoke the familiar sounds of bustling cafes, clinking cups, and lively conversations, creating the perfect backdrop for focus, creativity, and relaxation. Whether you're working, studying, or simply unwinding, The Originals offer a nostalgic and comforting atmosphere that has been beloved by our community for years.",
		imageUrlStub: "https://images.coffitivity.com/the-originals",
		releaseDate: "2013-03-03T11:29:55",
		tracks: [
			"aa885b1f-42bf-4e72-b120-60386cefad02",
			"28226607-f0ea-4d24-b1cf-afaf42de8554",
			"44dd90dd-c4ac-462e-80db-5fee51a61f67",
			"fb624356-91c1-455e-817c-b6d856f787f0",
			"9c9ccb8c-3370-4ecc-8076-28f9ea2468f4",
			"b96b544e-fe1f-4ae2-8051-4d398a5c194c",
		],
	},
	{
		id: "098fb84c-05ca-4ebd-b33a-5f02081a2264",
		name: "Spectrum",
		slug: "spectrum",
		type: AUDIO_GROUP_TYPE.ALBUM,
		collectionIds: ["collection:sound-color"],
		description:
			"The familiar sounds of our color spectrum. These utilitarian tracks are designed to provide a consistent and unobtrusive background ambiance, making them ideal for work, study, or relaxation. Each track is a carefully crafted range of tones across the auditory frequency spectrum.",
		releaseDate: "2025-03-03T11:30:04",
		imageUrlStub: "https://images.coffitivity.com/spectrum",
		tracks: [
			"ec233638-51de-4440-a0c2-e9d7842df21c",
			"8395cad7-00ba-4295-8c08-ef2b5f2908e9",
			"92c9a6bd-4015-428d-826d-b83f0fe1accc",
			"e008c6c6-b907-412d-bc4c-01502028e1e5",
			"a9485ae9-10aa-4309-8304-ef45a8aed020",
		],
	},
	{
		id: "194205c6-9587-48dc-8566-deb5c24cb5e3",
		name: "Tour in Italia",
		slug: "tour-in-italia",
		type: AUDIO_GROUP_TYPE.ALBUM,
		collectionIds: ["collection:cafe", "collection:soundscape"],
		description:
			"Experience the vibrant sounds of Italy's coffee culture with our 'Tour in Italia' album. This collection of tracks captures the lively ambiance of Italian cafes, from the bustling streets of Rome to the cozy corners of Naples. Each track immerses you in the rich tapestry of Italian life, featuring the clatter of espresso machines, animated conversations, and the melodic hum of daily activity. Whether you're working, studying, or simply seeking a moment of escape, 'Tour in Italia' transports you to the heart of Italy's coffee culture, providing an inspiring and energizing backdrop for your day.",
		releaseDate: "2025-08-01 10:00:00+00",
		imageUrlStub: "https://images.coffitivity.com/tour-in-italia",
		tracks: [
			"abe806bf-3049-4093-8e0c-789650bba16d",
			"97db5abf-e8f7-4e64-8029-53d4476b268e",
			"752fd074-aa74-45ea-922a-231a258e769a",
			"53ef8040-7dad-4574-9df9-c9637ac874de",
		],
	},
	{
		id: "443950e8-634e-4406-ae2e-2b0d2d4c147f",
		name: "A Touch of Grass",
		slug: "a-touch-of-grass",
		type: AUDIO_GROUP_TYPE.ALBUM,
		collectionIds: ["collection:soundscape"],
		description:
			"Step outside without leaving your desk. This collection brings the gentle sounds of nature into your workspace. Sounds like rustling leaves, distant birdsong, and the subtle movements of the natural world. Perfect for when you need to reset, breathe, and find your focus in the calm of the outdoors.",
		releaseDate: "2025-03-03T11:30:04",
		imageUrlStub: "https://images.coffitivity.com/a-touch-of-grass",
		tracks: [
			"080a48a8-31eb-46e6-a8a4-e86b217ed065",
			"4cebff8d-6b59-4d03-b8a0-7f72b2378266",
			"7c383061-2364-4b89-a83f-3e7d176cda4a",
			"66f34f55-9f9d-46a9-8a80-ad269a35b7bb",
			"c3085065-43f6-4cef-a192-4dc5701fd672",
			"8b964753-2930-42e9-b1db-8fb67a9bb200",
			"7b14070c-ebdb-4ed1-8402-1817186f9aff",
			"b470c28d-5cf2-471f-90e1-8089615ea952",
			"181df085-0998-4eff-95eb-a0fe07f20b5c",
			"9cc4d68d-24ab-4a5f-b1fa-a7d567a4dc2a",
			"98d34f56-dd50-4ace-8cf6-1cc5b98761e5",
			"fb9c62e8-4137-4e82-acc5-00cfa7341c7c",
		],
	},
	{
		id: "c328dc9a-73aa-425d-947d-37df3a5e68f7",
		name: "Urban Oasis",
		slug: "urban-oasis",
		type: AUDIO_GROUP_TYPE.ALBUM,
		collectionIds: ["collection:soundscape"],
		description:
			"The energy of the city, without the overwhelm. These tracks capture the rhythm of urban life (traffic hum, footsteps on pavement, the pulse of movement). For when you need that energized atmosphere to power through your work, minus the actual chaos.",
		releaseDate: "2025-03-03T11:30:04",
		imageUrlStub: "https://images.coffitivity.com/urban-oasis",
		tracks: [
			"fcf94f1a-6792-407e-ac99-97b33313d536",
			"9bbfd555-6217-4ebe-9acb-f402a5c2b78c",
			"a864329a-871a-4775-90b6-d89c962b3455",
			"1bf4c0bd-b6fa-4bdf-8cbd-a5035d80f510",
		],
	},
	{
		id: "26b9fadb-fd90-4200-98f7-46db2a9c4fb2",
		name: "Marketplace Melodies",
		slug: "marketplace-melodies",
		type: AUDIO_GROUP_TYPE.ALBUM,
		collectionIds: ["collection:soundscape"],
		description:
			"The buzz of human activity in its most vibrant form. Markets from around the world bring their unique energy. Hear vendor calls, footsteps, the flow of people going about their day. A lively backdrop for when you want to feel surrounded by life while you create.",
		releaseDate: "2025-10-06 10:00:00+00",
		imageUrlStub: "https://images.coffitivity.com/marketplace-melodies",
		tracks: [
			"5ae79d56-e4e6-4d52-b2e5-278a902cca6e",
			"cd1030d2-6270-426b-bfa5-cdba0cae611d",
			"1eb4d579-0359-4516-96b0-2e10a09bf564",
			"66b12c8d-a6a7-461d-8936-22814d7edb42",
			"42efe92d-5d8f-4a9c-a2c3-b8377cc56aaf",
			"f0e7d99e-590e-4cdf-899a-18434883316e",
		],
	},
	{
		id: "33156d32-82d5-4b0c-a3aa-5ecebe42f1ca",
		name: "Ethereal Echoes",
		slug: "ethereal-echoes",
		type: AUDIO_GROUP_TYPE.ALBUM,
		collectionIds: ["collection:moodscape", "collection:blend"],
		description:
			"Drift into something otherworldly. These atmospheric soundscapes blend ambient textures and subtle melodies to create a tranquil, reflective space. Ideal for deep work, meditation, or those moments when you need to float above the noise and find your center.",
		releaseDate: "2025-10-06 10:00:00+00",
		imageUrlStub: "https://images.coffitivity.com/ethereal-echoes",
		tracks: [
			"d4fccf6b-4536-4c91-8f39-ec32369623fe",
			"a15ed200-c513-4acd-9fb3-acdabe6f0d3b",
			"dbc24589-118f-4653-b6e1-cb61d48cf4a5",
			"b14e6544-9344-49c2-b41d-14d88826cd8f",
		],
	},
	{
		id: "26c81cb6-b1b7-43af-84ac-995fdbfd2d86",
		name: "Taste The World",
		slug: "taste-the-world",
		type: AUDIO_GROUP_TYPE.ALBUM,
		collectionIds: ["collection:cafe"],
		description:
			"Coffee culture, no passport required. This collection takes you café hopping around the globe. From bustling espresso bars in Bogotá to quiet corner cafés in Taipei. Each track captures the distinct character and rhythm of coffee shops across different cultures. Same familiar comfort, different accents.",
		releaseDate: "2025-10-06 10:00:00+00",
		imageUrlStub: "https://images.coffitivity.com/taste-the-world",
		tracks: [
			"075c08ea-7b7c-4a3c-8898-7b5c78ef77ec",
			"e0794e05-644b-4e18-96fd-d92741467d0b",
			"0d25d550-57b1-4cfa-9865-55dd2f84ccf2",
			"d3038d12-11ca-408e-b61e-0f61ebd0196b",
			"608a60c5-df8f-4893-8c20-13cec794529a",
			"b3c3ff99-00b3-45df-9d91-2a53b2edf2d5",
			"179753da-7d3b-4fcb-8f08-d48e45dc3787",
			"1cca9cde-7cbd-480f-a3e5-85a620030187",
			"037fc865-2ebb-4ccc-80cc-ebd983235894",
		],
	},
	{
		id: "7090b9f9-7f65-45e7-b39a-3d71aa99ba92",
		name: "A Fresh New Blend",
		slug: "a-fresh-new-blend",
		type: AUDIO_GROUP_TYPE.ALBUM,
		collectionIds: ["collection:blend"],
		description:
			"Sometimes the best atmosphere comes from mixing things up. These tracks layer different ambient elements together. Café sounds meeting nature, urban energy blending with calm. Each combination creates something new and unexpected, perfect for when you want familiar comfort with a twist.",
		releaseDate: "2025-10-06 10:00:00+00",
		imageUrlStub: "https://images.coffitivity.com/a-fresh-new-blend",
		tracks: [
			"52a5318b-3d12-41a6-a825-7b862732c0ed",
			"d4f67ec4-46e2-4249-9bc2-bf3f3a3c6ae0",
			"664081ee-4ee0-4494-9b27-774c6909e17c",
			"ecc46e32-8e45-4565-99ad-ab35a31c9eae",
			"4335a27f-f2c1-4707-a6af-100c7c81c235",
		],
	},
	// alpha
	{
		id: "0512a796-ba42-483d-b61c-4cc59fe45332",
		name: "Alpha Waves",
		slug: "alpha-waves",
		type: AUDIO_GROUP_TYPE.ALBUM,
		collectionIds: ["collection:brain-wave"],
		description:
			"The frequency of relaxed focus. Alpha waves oscillate between 8-14 Hz and are among the most studied brainwave states, consistently associated with calm alertness: the mental sweet spot between tension and drift. These tracks are designed to support creative thinking, light meditation, and stress reduction. Best for when you need to stay present without forcing it.",
		releaseDate: "2025-03-03 11:30:08+00",
		imageUrlStub: "https://images.coffitivity.com/alpha-waves",
		tracks: [
			"32cafc8c-955a-440d-b1b2-96c66a12190d",
			"b1ce9df2-c0ec-42fd-bbc1-22dc29041065",
			"72f3fca0-9cc2-4dda-b861-50c39933c17a",
			"9b483d14-152c-4c95-9646-197acff56fd6",
			"f222b8ba-652f-4fce-911e-4db4854dd28c",
			"e4f1b29e-a4b2-4059-80c9-bb0cc215cb7d",
		],
	},
	// isochronic alpha
	{
		id: "ac13c87b-0625-4a37-8715-15004f169c37",
		name: "Isochronic Alpha Waves",
		slug: "isochronic-alpha-waves",
		type: AUDIO_GROUP_TYPE.ALBUM,
		collectionIds: ["collection:brain-wave"],
		description:
			"The frequency of relaxed focus, no headphones required. Alpha waves oscillate between 8—14 Hz and are consistently associated with calm alertness: the mental sweet spot between tension and drift. Unlike binaural beats, isochronic tones pulse the beat frequency directly into the track, making them effective on speakers, earbuds, or any playback device. These tracks are designed to support creative thinking, light meditation, and stress reduction. Best for when you need to stay present without forcing it.",
		releaseDate: "2026-05-18 11:30:08+00",
		imageUrlStub: "https://images.coffitivity.com/isochronic-alpha-waves",
		tracks: [
			"24ba15c6-3fb9-4d15-a24a-6f93c9532b82",
			"fc6ee0ae-bb8b-4d72-951c-9dbe88ab029f",
			"36259db4-1492-4b40-a598-dfc2b54daba1",
			"66f35e33-e4a2-44d4-bb37-140105bcbc06",
			"a8dec14a-c9ae-4f8f-964c-7004408f0ae9",
			"062668bc-a3ac-452b-87fb-1c707175c970",
		],
	},
	// beta
	{
		id: "6d0e472d-a37c-4ab0-8c28-2d3ca711cb47",
		name: "Beta Waves",
		slug: "beta-waves",
		type: AUDIO_GROUP_TYPE.ALBUM,
		collectionIds: ["collection:brain-wave"],
		description:
			"Active mind, sharp focus. Beta waves oscillate between 14-30 Hz and dominate during analytical thinking, problem-solving, and sustained attention. These tracks are designed to support concentration during demanding tasks and decision-making. Research on beta entrainment is promising, though individual response varies. Find the carrier tone that keeps you in the zone.",
		releaseDate: "2025-03-03 11:30:08+00",
		imageUrlStub: "https://images.coffitivity.com/beta-waves",
		tracks: [
			"d1028ba7-59ad-4142-ae6a-c8e3c30dac60",
			"fec51d2a-5272-4085-9e39-61fc1985a6dc",
			"f5772f23-8b77-461c-9623-572155f56156",
			"387af647-432e-4920-9eab-7e0ef37e7176",
			"0c451896-2f6e-4910-8ffd-57c822fa238b",
			"2323d4c0-f346-4991-9c9b-1d39bd2528e4",
		],
	},
	// isochronic beta
	{
		id: "a4e830ae-28ab-40fa-9e49-93dd625ef0fe",
		name: "Isochronic Beta Waves",
		slug: "isochronic-beta-waves",
		type: AUDIO_GROUP_TYPE.ALBUM,
		collectionIds: ["collection:brain-wave"],
		description:
			"Active mind, sharp focus wherever you're listening. Beta waves oscillate between 14—30 Hz and dominate during analytical thinking, problem-solving, and sustained attention. Isochronic tones deliver the beat frequency as a direct rhythmic pulse, so they work without headphones making these tracks a practical choice for open offices, shared spaces, or anyone who finds in-ear listening uncomfortable during long work sessions. Individual response varies. Find the volume and layering that keeps you in the zone.",
		releaseDate: "2026-05-18 11:30:08+00",
		imageUrlStub: "https://images.coffitivity.com/isochronic-beta-waves",
		tracks: [
			"75ecdd8f-4fdd-49ab-9407-9ae64a1c9720",
			"829a583b-e774-4242-8630-e6e11a354b2f",
			"56ebd715-0a3f-47cb-bc2d-bad318ac3a6d",
			"019e76a6-6c09-493e-9777-c89f6c4d4577",
			"a5a7d8b8-23e8-4945-bf39-953500f68103",
			"f004a1cd-a1c0-45ee-bfb8-7d52568dac16",
		],
	},
	// delta
	{
		id: "48ff31a9-912c-4c00-9636-b608c8d7c7b7",
		name: "Delta Waves",
		slug: "delta-waves",
		type: AUDIO_GROUP_TYPE.ALBUM,
		collectionIds: ["collection:brain-wave"],
		description:
			"Deep rest, nothing more. Delta waves oscillate between 0.5-4 Hz and are the slowest brainwave frequencies, naturally dominant during deep sleep. These tracks are designed to support relaxation and winding down. Not a substitute for sleep, but a useful tool for getting there. Best used for meditation, recovery, or when your mind needs to genuinely slow down.",
		releaseDate: "2025-03-03 11:30:08+00",
		imageUrlStub: "https://images.coffitivity.com/delta-waves",
		tracks: [
			"fb6b7fd3-f96b-4441-98ca-108f8dd6f3ad",
			"c6e99ae8-74e2-415e-83b3-6312db5750da",
			"f80b37a6-fd47-4b2f-9efe-777edeedd614",
			"31e4e197-b343-420e-8e5d-ac6fc5751670",
			"7f8f5582-6667-49e6-8566-debe72d4fa72",
			"48ec7729-2183-4601-82f5-d66962586fd4",
		],
	},
	// isochronic delta
	{
		id: "95b6d34b-1533-464c-8004-db625435fc1c",
		name: "Isochronic Delta Waves",
		slug: "isochronic-delta-waves",
		type: AUDIO_GROUP_TYPE.ALBUM,
		collectionIds: ["collection:brain-wave"],
		description:
			"Deep rest, nothing more — and no headphones needed. Delta waves oscillate between 0.5—4 Hz and are the slowest brainwave frequencies, naturally dominant during deep sleep. Isochronic tones at delta frequencies produce a slow, deliberate pulse that some users find easier to relax into than the subtler binaural effect. Not a substitute for sleep, but a useful tool for getting there. Best for meditation, recovery, or winding down.",
		releaseDate: "2026-05-18 11:30:08+00",
		imageUrlStub: "https://images.coffitivity.com/isochronic-delta-waves",
		tracks: [
			"a5813139-502e-4161-ba2a-38cbf45e9358",
			"d8c46793-cb25-419f-91ab-7fbb6ebab472",
			"65dc1d8d-3090-440a-9858-3bf20c14c871",
			"f1b70652-80d4-4699-a01b-c6216c52368d",
			"5f864776-e8eb-4b6b-86e3-7a079e9d2f82",
			"065265bf-e572-4753-b09e-3e7c5de355b1",
		],
	},
	// gamma
	{
		id: "5d8afeca-8ca4-4cd5-a69c-ec53fdb5889c",
		name: "Gamma Waves",
		slug: "gamma-waves",
		type: AUDIO_GROUP_TYPE.ALBUM,
		collectionIds: ["collection:brain-wave"],
		description:
			"High-frequency cognition. Gamma waves oscillate between 30-100 Hz and are associated with complex processing, memory consolidation, and moments of insight. 40 Hz gamma in particular has attracted serious scientific attention in recent years. These tracks are designed to support your most demanding mental work. Among the more actively researched frequencies in the collection.",
		releaseDate: "2025-03-03 11:30:08+00",
		imageUrlStub: "https://images.coffitivity.com/gamma-waves",
		tracks: [
			"db24e94b-a4af-43ae-8c31-898c4ab5a8bc",
			"96857519-6ff8-491f-ae3f-68fcb3bc385c",
			"205db1fe-9425-461b-b8c8-9ba95b744dbb",
			"b8e204d4-9d1d-4bbb-9d40-ab7f0adb57b9",
			"88df0a23-369c-4999-a0e1-19f15ee5a4d7",
			"db62a850-ea24-45a0-9295-5558b73dba5c",
		],
	},
	// isochronic gamma
	{
		id: "85c5c208-b0c2-4f6a-bb78-61d83d3406f8",
		name: "Isochronic Gamma Waves",
		slug: "isochronic-gamma-waves",
		type: AUDIO_GROUP_TYPE.ALBUM,
		collectionIds: ["collection:brain-wave"],
		description:
			"High-frequency cognition, speaker-friendly. Gamma waves oscillate between 30—100 Hz and are associated with complex processing, memory consolidation, and moments of insight. 40 Hz gamma in particular has attracted serious scientific attention in recent years. At higher beat frequencies like gamma, isochronic tones produce a more noticeable rhythmic pulse than lower wave types. Some users find this energizing, others prefer to keep the volume lower in a blend. Among the more actively researched frequencies in the collection.",
		releaseDate: "2026-05-18 11:30:08+00",
		imageUrlStub: "https://images.coffitivity.com/isochronic-gamma-waves",
		tracks: [
			"7019decb-169e-4de0-b6a2-8cfc75d5b9ed",
			"c8bbe107-d9a6-4027-b95e-2fcaf779463b",
			"0bd6596f-c183-40bc-a5d6-68c573b65601",
			"c21788c5-f20c-4757-b99f-1775e6b1b648",
			"fc685cbb-e001-42e9-97ee-f47d5d7a3d1b",
			"ea386585-4f78-4818-b74e-0c749d701916",
		],
	},
	// theta
	{
		id: "96e3eb57-72f1-49d7-8872-8e2e6082806d",
		name: "Theta Waves",
		slug: "theta-waves",
		type: AUDIO_GROUP_TYPE.ALBUM,
		collectionIds: ["collection:brain-wave"],
		description:
			"The edge between waking and dreaming. Theta waves oscillate between 4-8 Hz and naturally emerge during deep meditation and the drowsy state before sleep. These tracks are designed to support reflective thinking and creative ideation: states where the mind is loose enough to make unexpected connections. Best for brainstorming, journaling, or intentional rest.",
		releaseDate: "2025-03-03 11:30:08+00",
		imageUrlStub: "https://images.coffitivity.com/theta-waves",
		tracks: [
			"3a765ab7-0133-42b5-8913-6c931d530322",
			"b5402485-6174-442a-b7b3-08555cb2cfea",
			"0779221c-0369-4eb2-ad24-544c74985530",
			"4693df70-4652-4139-ba63-0e7517308177",
			"af22ab44-e552-4944-861f-86309199592e",
			"70334aaf-5b88-476c-8d4c-0b5baa6491cd",
		],
	},
	// isochronic theta
	{
		id: "d5d1eb0c-d15b-4b31-b4ae-80924ba74e96",
		name: "Isochronic Theta Waves",
		slug: "isochronic-theta-waves",
		type: AUDIO_GROUP_TYPE.ALBUM,
		collectionIds: ["collection:brain-wave"],
		description:
			"The edge between waking and dreaming, no headphones required. Theta waves oscillate between 4—8 Hz and naturally emerge during deep meditation and the drowsy state before sleep. Isochronic tones at theta frequencies produce a gentle, slow pulse that can feel more tangible than binaural beats for users new to brainwave entrainment. A good starting point if you're exploring the collection for the first time. Best for brainstorming, journaling, or intentional rest.",
		releaseDate: "2026-05-18 11:30:08+00",
		imageUrlStub: "https://images.coffitivity.com/isochronic-theta-waves",
		tracks: [
			"b7998d79-4271-49b8-bd03-5917ff024091",
			"e3ea2ffa-32dd-4189-8196-fbdabcf14e5d",
			"ede3d993-2504-458a-a772-4451121b1390",
			"38e27537-e79b-4c06-ae44-41f8e9842c33",
			"f8720fc6-3839-44b7-976f-c61a4d37442f",
			"e3878b78-2ae7-4e07-9665-98ed0c02bdd7",
		],
	},
];
